"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.form.hero.title': 'Dołącz do IntHub',
    'register.form.hero.description': 'Użyj tego formularza do rejestracji.',
    'register.form.hero.login_link_text': 'Jeśli już jesteś członkiem, proszę',
    'register.form.hero.login_link': 'zaloguj się tutaj.',
};
